<template>
  <div class="w1200 orderlist">
      <div class="mtitle">修改个人资料</div>
    <div class="infor">
<el-form ref="form" :model="form" label-width="100px" label-position="right">
        <el-row :gutter="60">
            <el-col :span="12">
                <el-form-item label="用户名：">
                    <div class="bold f16">{{username}}</div>
                </el-form-item>
                <el-form-item label="手机号：">
                    <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="邮箱：">
                    <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" @click="send" class="tjbtn">修改资料</el-button>
                </el-form-item>
            </el-col>
             <el-col :span="12">
                <el-form-item label="机构或公司：">
                    <el-input v-model="form.jggs" placeholder="请输入机构或公司"></el-input>
                </el-form-item>
                <el-form-item label="姓名：">
                    <el-input v-model="form.realname" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="微信号：">
                    <el-input v-model="form.wxh" placeholder="请输入微信号"></el-input>
                </el-form-item>
            </el-col>
        </el-row>    
   
</el-form>
            
        </div>
        <div class="mtitle">修改密码</div>
        <div class="infor">
<el-form ref="form2" :model="form2" label-width="100px" label-position="right">
        <el-row :gutter="60">
            <el-col :span="12">
                <el-form-item label="原密码：">
                    <el-input v-model="form2.oldPassword" type="password" placeholder="请输入原密码"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" @click="send2" class="tjbtn">修改密码</el-button>
                </el-form-item>
            </el-col>
             <el-col :span="12">
                <el-form-item label="新密码：">
                    <el-input v-model="form2.newPassword" type="password" placeholder="请输入新密码"></el-input>
                </el-form-item>
              
            </el-col>
        </el-row>    
   
</el-form>
            
        </div>
  </div>
</template>

<script>
import { refreshUser,editProfile,changePassword } from "@/api/index.js"
export default {
  data() {
    return {
        form:{
        realname:this.$store.state.userInfo.realname,
         mobile:this.$store.state.userInfo.mobile,
         email:this.$store.state.userInfo.email,
         wxh:this.$store.state.userInfo.wxh,
         jggs:this.$store.state.userInfo.jggs
        },
        form2:{
            oldPassword:'',
            newPassword:''
        }
       
    }
  },
  computed: {
    username() {
      return  this.$store.state.username
    }
  },
  mounted(){
   
  },
  methods:{
    send(){
        editProfile(this.form).then(res=>{
            if(res.code==1){
               this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
            }
        })
    },
    send2(){
        changePassword(this.form2).then(res=>{
            if(res.code==1){
               this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                localStorage.clear();
              this.$router.push('/login')   
            }
        })
    }
  }
};
</script>

<style lang="less">
.infor {
    margin-top:30px;
    .el-form-item__label {font-weight: bold!important;}
    .tjbtn {
        font-size: 20px;background:#2397CA;margin-top:10px;width:40%;
    }
}
</style>
